import React from 'react';
import { withFormik, Form, Field } from 'formik';

const FormContainer = ({ values, errors, touched, isSubmitting }, props) => (
  <section className="bg-alt">
    <div className="container">
      <div className="row">
        <div className="col-lg-8 mx-lg-auto text-center">
          <h2 className="margin-top-0 wow fadeIn">Get in Touch</h2>
          <hr className="accent" />
          <p>We love feedback. Fill out the form below and we&apos;ll get back to you as soon as possible.</p>
        </div>
        <div className="col-lg-10 mx-lg-auto text-center">
          <Form action="https://formspree.io/info@businessdna.net" method="POST" className="contact-form row">
            <input type="hidden" name="_next" value="https://www.businessdna.net" />
            <input type="hidden" name="_subject" value="Businessdna.net - 📧 📧 📧 - New message from our site!" />
            <div className="col-md-4">
              <label />
              {touched.name && errors.name && <p>{errors.name}</p>}
              <Field name="name" type="text" placeholder="Name" className="form-control" />
            </div>
            <div className="col-md-4">
              <label />
              {touched.email && errors.email && <p>{errors.email}</p>}
              <Field name="email" type="email" placeholder="Email" className="form-control" />
            </div>
            <div className="col-md-4">
              <label />
              {touched.phone && errors.phone && <p>{errors.phone}</p>}
              <Field name="phone" type="text" placeholder="Phone" className="form-control" />
            </div>
            <div className="col-md-12">
              <label />
              {touched.message && errors.message && <p>{errors.message}</p>}
              <Field name="message" className="form-control" rows="9" placeholder="Your message here.." />
            </div>
            <div className="col-md-4 ml-md-auto">
              <label />
              {/* <input type="submit" value="Send Message" className="btn btn-outline-dark btn-block btn-lg" /> */}
              <button disabled={isSubmitting} className="btn btn-outline-dark btn-block btn-lg">
                Submit
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </section>
);

const ContactForm = withFormik({
  mapPropsToValues({ name, email, phone, message }) {
    return {
      name: name || '',
      email: email || '',
      phone: phone || '',
      message: message || '',
    };
  },
  // validationSchema: Yup.object().shape({
  //   name: Yup.string().required('Name is required'),
  //   email: Yup.string()
  //     .email('Email not valid')
  //     .required('Email is required'),
  //   phone: Yup.string().required('Phone is required'),
  //   message: Yup.string().required('Message is required'),
  // }),
  handleSubmit(values, { resetForm, setErrors, setSubmitting }) {
    setSubmitting(false);
  },
})(FormContainer);

export default ContactForm;



// WEBPACK FOOTER //
// ./src/components/Contact.js